import { maxBy } from "lodash";
import { useMemo } from "react";
import { dictionaryService } from "../../../dataFlow";
import { OLAPTransformerResult, useParameter, useDictionary, Column } from "../../../shared";

const CATEGORY_AXIS = "calendar.default";

export function useCorrelationLabel(olapIndexData: OLAPTransformerResult | null) {
  const correlationLabel = useMemo(() => {
    const row = olapIndexData?.rows[0];
    const point = row?.points[0];
    if (point) {
      const { correlation } = point as any;
      const formatter = Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
      return formatter.format(correlation);
    }
    return '';
  }, [olapIndexData]);
  return correlationLabel;
}